// @flow
import React, { useContext } from 'react';

import ReactResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { TextSeeMore } from 'Components/frameworks/text-see-more/TextSeeMore';

export type OfferLegalInformationLineProps = {
  config: {
    common: {
      loadLess: string,
    },
  },
  offer?: {
    legalInformation: string,
  },
  seeMore: string,
};

export const OfferLegalInformationLine = ({
  config,
  offer,
  seeMore,
}: OfferLegalInformationLineProps) => {
  const { isDesktop } = useContext(ReactResponsiveContext);
  if (!offer || !offer.legalInformation) {
    return null;
  }

  return (
    <div className="Line Line-Offer-Legal-Information">
      <SiteContainer>
        <TextSeeMore
          text={offer.legalInformation}
          theme="text-sans-2"
          seeMoreLabel={seeMore}
          seeLessLabel={config.common.loadLess}
          isCollapseEnabled={!isDesktop}
        />
      </SiteContainer>
    </div>
  );
};
